import React, { useState } from 'react';
import {
  Stack,
  Flex,
  Box,
  Heading,
  Text,
  Button,
  Image,
  Icon,
  IconButton,
  createIcon,
  IconProps,
  useColorModeValue,
} from '@chakra-ui/react';
import YouTube from 'react-youtube';

interface InfoHeroProps {
  scrollTo: () => void;
}

export default function InfoHero(props: InfoHeroProps) {
  const { scrollTo } = props;
  const [isVideoDisplayed, setIsVideoDisplayed] = useState(false);
  const toggleVideo = () => {
    setIsVideoDisplayed(!isVideoDisplayed);
  };

  return (
    <Stack
      sx={{
        '.yt-container': {
          position: 'relative',
          overflow: 'hidden',
          width: '100%',
        },
        '.yt-container::after': {
          display: 'block',
          content: '""',
          paddingBottom: '56.25%',
        },
        '.yt-container iframe': {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        },
      }}
      align={'center'}
      pt={{ base: 4, md: 4, lg: 40 }}
      pb={{ base: 20, md: 28, lg: 40 }}
      direction={{ base: 'column', lg: 'row' }}
      maxW="8xl"
      spacing={0}
      gap={{ base: 16, lg: 4 }}
    >
      <Stack flex={1} spacing={{ base: 5, md: 10 }}>
        <Heading
          lineHeight={1.1}
          fontWeight={900}
          fontSize={{ base: '32px', sm: '46px', lg: '60px' }}
        >
          <Text as={'span'} position={'relative'} color="#e34c82">
            Tech Industry
          </Text>
          <br />
          <Text as={'span'} color={'#2256ff'}>
            In Your Classroom
          </Text>
        </Heading>
        <Text color={'gray.500'}>
          Prepare your students for Jobs of the Future with Experiential
          Industry-based STEM programs.
        </Text>
        <Stack
          spacing={{ base: 4, sm: 6 }}
          direction={{ base: 'column', sm: 'row' }}
        >
          <Button
            rounded={'md'}
            size={'lg'}
            px={6}
            colorScheme="stemiRed"
            color="#FFF"
            fontWeight="700"
            fontSize="16px"
            onClick={scrollTo}
          >
            EXPLORE PROGRAMS
          </Button>
          {/* <Button
            // onClick={() => setIsVideoDisplayed(true)}
            size={'lg'}
            px={6}
            rounded={'md'}
            bg={'#2256ff'}
            _hover={{ bg: '#2256ff' }}
            color="#FFF"
            fontWeight="700"
            fontSize="16px"
            leftIcon={<PlayIcon h={4} w={4} color={'gray.300'} />}
          >
            HOW IT WORKS
          </Button> */}
        </Stack>
      </Stack>
      <Flex
        flex={1}
        justify={'center'}
        align={'center'}
        position={'relative'}
        w={'full'}
      >
        <Blob
          w={'150%'}
          h={'150%'}
          position={'absolute'}
          top={'-20%'}
          left={0}
          zIndex={-1}
          // color={useColorModeValue('red.50', 'red.400')}
        />
        <Box
          position={'relative'}
          // height={'300px'}
          rounded={'2xl'}
          boxShadow={'2xl'}
          width={'full'}
          overflow={'hidden'}
        >
          {isVideoDisplayed ? (
            <Box w="100%" h="100%">
              <div className="yt-container">
                <YouTube
                  videoId="xtITBGaV2kc"
                  title="hero-video"
                  onReady={(e) => e.target.playVideo()}
                />
              </div>
            </Box>
          ) : (
            <>
              {/* <IconButton
                aria-label={'Play Button'}
                variant={'ghost'}
                _hover={{ bg: 'transparent' }}
                icon={<PlayIcon w={12} h={12} />}
                size={'lg'}
                color={'white'}
                position={'absolute'}
                left={'50%'}
                top={'50%'}
                transform={'translateX(-50%) translateY(-50%)'}
                // onClick={toggleVideo}
              /> */}
              <Image
                alt={'Hero Image'}
                fit={'cover'}
                align={'center'}
                w={'100%'}
                h={'100%'}
                src={'/static/ui/hero.png'}
              />
            </>
          )}
        </Box>
      </Flex>
    </Stack>
  );
}

const PlayIcon = createIcon({
  displayName: 'PlayIcon',
  viewBox: '0 0 58 58',
  d: 'M28.9999 0.562988C13.3196 0.562988 0.562378 13.3202 0.562378 29.0005C0.562378 44.6808 13.3196 57.438 28.9999 57.438C44.6801 57.438 57.4374 44.6808 57.4374 29.0005C57.4374 13.3202 44.6801 0.562988 28.9999 0.562988ZM39.2223 30.272L23.5749 39.7247C23.3506 39.8591 23.0946 39.9314 22.8332 39.9342C22.5717 39.9369 22.3142 39.8701 22.0871 39.7406C21.86 39.611 21.6715 39.4234 21.5408 39.1969C21.4102 38.9705 21.3421 38.7133 21.3436 38.4519V19.5491C21.3421 19.2877 21.4102 19.0305 21.5408 18.8041C21.6715 18.5776 21.86 18.3899 22.0871 18.2604C22.3142 18.1308 22.5717 18.064 22.8332 18.0668C23.0946 18.0696 23.3506 18.1419 23.5749 18.2763L39.2223 27.729C39.4404 27.8619 39.6207 28.0486 39.7458 28.2713C39.8709 28.494 39.9366 28.7451 39.9366 29.0005C39.9366 29.2559 39.8709 29.507 39.7458 29.7297C39.6207 29.9523 39.4404 30.1391 39.2223 30.272Z',
});

export const Blob = (props: IconProps) => {
  return (
    <>
      <Icon
        width="100%"
        viewBox="0 0 658 582"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        transform={'translate(20%,0) rotate(-15deg)'}
        color="#2256ff"
        {...props}
      >
        <path
          d="M472.542.207H185.294c-14.73 0-28.724 8.103-36.09 20.994L5.581 270.186a41.96 41.96 0 0 0 0 41.62L149.204 560.79c7.366 12.892 21.36 20.995 36.09 20.995h287.248c14.73 0 28.724-8.103 36.09-20.995l143.623-248.984a41.956 41.956 0 0 0 0-41.62L508.632 21.201C501.266 8.311 487.272.207 472.542.207Z"
          fill="currentColor"
        ></path>
      </Icon>
      <Icon
        width="100%"
        viewBox="0 0 427 781"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        color="#e34c82"
      >
        <g clipPath="url(#clip0_739_913)" fill="currentColor">
          <path d="M424.84 781.011a2.161 2.161 0 1 0-.002-4.322 2.161 2.161 0 0 0 .002 4.322ZM319.173 781.011a2.161 2.161 0 1 0-.002-4.322 2.161 2.161 0 0 0 .002 4.322ZM213.496 781.011a2.161 2.161 0 1 0-.002-4.322 2.161 2.161 0 0 0 .002 4.322ZM107.827 781.011a2.162 2.162 0 0 0 0-4.323 2.16 2.16 0 0 0 0 4.323ZM2.16 781.011a2.161 2.161 0 1 0-.002-4.322 2.161 2.161 0 0 0 .002 4.322ZM424.84 683.922a2.16 2.16 0 1 0-.002-4.322 2.16 2.16 0 0 0 .002 4.322ZM319.173 683.922a2.16 2.16 0 1 0-.002-4.322 2.16 2.16 0 0 0 .002 4.322ZM213.496 683.922a2.16 2.16 0 1 0-.002-4.322 2.16 2.16 0 0 0 .002 4.322ZM107.827 683.922a2.162 2.162 0 1 0-.001-4.323 2.162 2.162 0 0 0 .001 4.323ZM2.16 683.922a2.16 2.16 0 1 0-.001-4.322 2.16 2.16 0 0 0 .001 4.322ZM424.84 586.833a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM319.173 586.833a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM213.496 586.833a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM107.827 586.833a2.161 2.161 0 1 0 0-4.322 2.161 2.161 0 0 0 0 4.322ZM2.16 586.833a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM424.84 489.744a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM319.173 489.744a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM213.496 489.744a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM107.827 489.744a2.161 2.161 0 1 0 0-4.322 2.161 2.161 0 0 0 0 4.322ZM2.16 489.744a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM424.84 392.666a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM319.173 392.666a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM213.496 392.666a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM107.827 392.666a2.161 2.161 0 1 0 0-4.322 2.161 2.161 0 0 0 0 4.322ZM2.16 392.666a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM424.84 295.578a2.16 2.16 0 1 0-.002-4.322 2.16 2.16 0 0 0 .002 4.322ZM319.173 295.578a2.16 2.16 0 1 0-.002-4.322 2.16 2.16 0 0 0 .002 4.322ZM213.496 295.578a2.16 2.16 0 1 0-.002-4.322 2.16 2.16 0 0 0 .002 4.322ZM107.827 295.578a2.162 2.162 0 1 0-.001-4.323 2.162 2.162 0 0 0 .001 4.323ZM2.16 295.578a2.16 2.16 0 1 0-.001-4.322 2.16 2.16 0 0 0 .001 4.322ZM424.84 198.489a2.16 2.16 0 1 0-.002-4.322 2.16 2.16 0 0 0 .002 4.322ZM319.173 198.489a2.16 2.16 0 1 0-.002-4.322 2.16 2.16 0 0 0 .002 4.322ZM213.496 198.489a2.16 2.16 0 1 0-.002-4.322 2.16 2.16 0 0 0 .002 4.322ZM107.827 198.489a2.162 2.162 0 1 0-.001-4.323 2.162 2.162 0 0 0 .001 4.323ZM2.16 198.489a2.16 2.16 0 1 0-.001-4.322 2.16 2.16 0 0 0 .001 4.322ZM424.84 101.4a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM319.173 101.4a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM213.496 101.4a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM107.827 101.4a2.16 2.16 0 1 0 0-4.322 2.16 2.16 0 0 0 0 4.322ZM2.16 101.4a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32ZM424.84 4.322a2.16 2.16 0 1 0-.001-4.32 2.16 2.16 0 0 0 .001 4.32ZM319.173 4.322a2.16 2.16 0 1 0-.001-4.32 2.16 2.16 0 0 0 .001 4.32ZM213.496 4.322a2.16 2.16 0 1 0-.001-4.32 2.16 2.16 0 0 0 .001 4.32ZM107.827 4.322a2.161 2.161 0 1 0 0-4.323 2.161 2.161 0 0 0 0 4.323ZM2.16 4.322a2.16 2.16 0 1 0 0-4.321 2.16 2.16 0 0 0 0 4.321Z"></path>
        </g>
        <defs>
          <clipPath id="clip0_739_913">
            <path fill="#fff" d="M0 0h427v781H0z"></path>
          </clipPath>
        </defs>
      </Icon>
    </>
  );
};
